<template>
  <v-row align="center">
      <v-col cols="3" align="start">
        <v-card :height="getHeight" width="200">
          <v-img :src="item.thumbnailUrl" contain transition="scale-transition" :height="getHeight" width="200"/>
        </v-card>
      </v-col>
      <v-col>{{ item.name }}</v-col>
      <v-col cols="4" class="text-right">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              {{ $t('downloadFile') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item link v-for="format in formats" :key="format.id">
              <v-list-item-title @click="download(item, format)">{{ format.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DownloadItem",
  props: {
    item: {type: Object},
    formats: {type: Array}
  },
  methods: {
    download(item, format) {
      this.$emit("downloadItem", {itemId: item.id, formatId: format.id})
    }
  },
  computed:{
    getHeight(){
      if(this.$vuetify.breakpoint.smAndDown){
        return 100
      }
      return 200
    }
  }
}
</script>

<style scoped>

</style>
